export const JSON_ONE = {
  "fromDate": "2017-10-30T00:00:00.000Z",
  "toDate": "2018-10-30T00:00:00.000Z"
}

export const JSON_TWO = {
    "settlement_ID": 134163,
    "aG_ID": "paygate",
    "merchant_ID": "201712050001",
    "merchant_Name": "Adidas",
    "aG_Ref": "1038070064955555840",
    "order_Number": "95214",
    "transaction_Type": "R",
    "amount": -1,
    "fee": 0,
    "mE_IGST": 0,
    "mE_CGST": 0,
    "mE_SGST": 0,
    "net_Amount": -1,
    "settlement_Date": "2020-03-13 11:35:57.0",
    "transaction_Date": "2020-03-09 00:00:00.0",
    "pG_ID": 192,
    "pG_Name": "BOB PG",
    "uDF1": "",
    "uDF2": "",
    "uDF3": "",
    "uDF4": "",
    "uDF5": ""
}
